import { QueryStringSearch } from '@diamond/shared/types';
import { apiInstance } from '@diamond/shared/utils';
import cleanDeep from 'clean-deep';

export const getListTemplate = async (
  token: string,
  params: Readonly<QueryStringSearch>
) => {
  const url = '/order/template';
  const { data } = await apiInstance(token).get(url, {
    params: cleanDeep(params),
  });
  return data;
};

export const getListTemplateDetail = async (
  token: string,
  id: string,
  warehouse: string
) => {
  const url = '/order/template';
  const { data } = await apiInstance(token).get(
    `${url}/${id}?warehouse=${warehouse}`
  );
  return data;
};

export const getListTemplateItem = async (
  token: string,
  id: string,
  warehouse: string,
  params: Readonly<QueryStringSearch>
) => {
  const url = '/order/template';
  const { data } = await apiInstance(token).get(
    `${url}/${id}/item?warehouse=${warehouse}`,
    {
      params: cleanDeep(params),
    }
  );
  return data;
};
